import { Injectable } from "@angular/core";
import { MapHelperService } from "../../../../services/map-helper.service";
import { LayerDTO } from "../models/LayerDTO";

@Injectable({
  providedIn: "root",
})
export class PanelMapLayerService {
  capas = new Array<LayerDTO>();

  isTrafficLayer: boolean = false;
  isStreetViewLayer: boolean = false;


  constructor(
    private MapHelper: MapHelperService,
  ) {

  }

  onToggleLayerTraffic(){
    this.isTrafficLayer = !this.isTrafficLayer;
    var visibilityValue = 'none';

    if(this.isTrafficLayer)
      visibilityValue = 'visible';

    this.MapHelper.toggleTraficLayer(visibilityValue);
  }

  deactivateLayerTraffic(){
    this.isTrafficLayer = false;
    var visibilityValue = 'none';

    if(this.isTrafficLayer)
      visibilityValue = 'visible';

    this.MapHelper.toggleTraficLayer(visibilityValue);
  }

}
